import { groupBy, keys, mapValues, orderBy } from 'lodash';

export default (productOrders) => {
  const formattedProductOrders = aggregateProductOrders(productOrders);

  return orderBy(
    formattedProductOrders,
    ['receptionDate', 'supplier', 'subCategory', 'name'],
    ['desc', 'asc', 'asc', 'asc'],
  );
};

const aggregateProductOrders = (productOrders) => {
  const groupedOrders = groupByMultipleKeys(productOrders, [
    'order.deliveryDate',
    'supplierProduct.id',
  ]);

  return keys(groupedOrders).reduce((result, deliveryDate) => {
    keys(groupedOrders[deliveryDate]).forEach((supplierProductId) => {
      const productOrder = groupedOrders[deliveryDate][supplierProductId].reduce(
        (info, current) => {
          const isQuantityValid = !isNaN(current.ordered.quantity);

          const totalInclTaxes =
            current.ordered.quantity *
            current.ordered.price *
            (1 + (current.supplierProduct.vatRate || 0) / 100);

          return {
            sku: current.supplierProduct.sku,
            receptionDate: current.order.startOrderDate,
            name: current.supplierProduct.name,
            supplier: current.supplier.name,
            subCategory: current.supplierProduct.subCategory,
            packagingName: current.supplierProduct.packagings.find(
              ({ isUsedInOrder }) => isUsedInOrder,
            ).name,
            vatRate: current.supplierProduct.vatRate,
            ordered: info.ordered + (isQuantityValid ? current.ordered.quantity : 0),
            totalExclTaxes:
              info.totalExclTaxes +
              (isQuantityValid ? current.ordered.quantity * current.ordered.price : 0),
            totalInclTaxes: info.totalInclTaxes + (isQuantityValid ? totalInclTaxes : 0),
          };
        },
        {
          ordered: 0,
          totalExclTaxes: 0,
          totalInclTaxes: 0,
        },
      );

      result.push({ ...productOrder, deliveryDate });
    });

    return result;
  }, []);
};
const groupByMultipleKeys = (array, keys) => {
  if (!keys.length) {
    return array;
  }

  const first = keys[0];

  const rest = keys.slice(1);

  return mapValues(groupBy(array, first), (value) => groupByMultipleKeys(value, rest));
};
